<div
	class="flex flex-col items-center flex-1 justify-center"
	*ngIf="!titleInsuranceProvider"
>
	<div class="w-120">
		<img
			src="/assets/images/empty-states/title-insurance.svg"
			alt="No title insurance selected image"
		/>
	</div>

	<h4 class="mt-4">Add title insurance</h4>
	<p>Order title insurance via your preferred provider</p>
	<app-button
		[icon]="ICON.ADD"
		(click)="addTitleInsurance()"
		size="small"
		class="mt-5"
		[testHook]="testHooks.AddTitleInsuranceButton"
		>Add title insurance</app-button
	>
</div>

<app-fct *ngIf="titleInsuranceProvider === provider.FCT"></app-fct>
<app-manual-title-insurance
	*ngIf="titleInsuranceProvider === provider.MANUAL"
></app-manual-title-insurance>
<app-chicago *ngIf="titleInsuranceProvider === provider.CHICAGO"></app-chicago>
<app-stewart *ngIf="titleInsuranceProvider === provider.STEWART"></app-stewart>
<app-title-plus
	*ngIf="titleInsuranceProvider === provider.TITLE_PLUS"
></app-title-plus>
